import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SiteHeader from '../components/common/SiteHeader';

function FAQPage() {
  const navigate = useNavigate();

  const handleBackToHome = (e) => {
    e.preventDefault();
    navigate('/');
    setTimeout(() => {
      const faqSection = document.getElementById('faq');
      if (faqSection) {
        faqSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-primary-200 flex flex-col">
      <SiteHeader />

      <main className="flex-1 py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-extrabold text-primary-700 mb-8 text-center">
            Frequently Asked Questions
          </h1>

          <div className="space-y-6">
            <FAQItem
              question="Is My Video Gallery really free?"
              answer="Yes, completely free. There are no limits on the number of galleries or videos you can create, and no premium tiers. This service runs on donations only."
            />

            <FAQItem
              question="Do viewers need accounts to see my gallery?"
              answer="No. For public galleries, anyone with the link can view them. For private galleries, you invite people by email, and they don't need accounts on YouTube, Vimeo, or other platforms."
            />

            <FAQItem
              question="What video platforms are supported?"
              answer="Currently, we support YouTube, Vimeo, and Dailymotion. More platforms are coming soon!"
            />

            <FAQItem
              question="Can I make my gallery private?"
              answer="Yes. You can create public galleries (accessible to anyone with the link) or private galleries where you control who has access by inviting specific people via email."
            />

            <FAQItem
              question="How do I invite people to my private gallery?"
              answer="When creating or editing a private gallery, you can invite people by entering their email addresses. They'll receive an invitation and be able to access your gallery."
            />

            <FAQItem
              question="Can I add custom descriptions to videos?"
              answer="Yes! You can add your own titles and descriptions to any video, providing context that the original creator didn't include."
            />

            <FAQItem
              question="What happens if a video is deleted from YouTube/Vimeo?"
              answer="If the original video is removed from the platform, it will no longer play in your gallery, but the entry will remain so you know what was there."
            />
          </div>

          <div className="mt-12 text-center">
            <Link
              to="/"
              onClick={handleBackToHome}
              className="inline-block px-6 py-3 bg-primary-500 text-white rounded-lg shadow hover:bg-primary-600 hover:shadow-lg font-semibold transition-all duration-200"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </main>

      <footer className="py-6 text-center text-gray-500 text-sm bg-white border-t border-primary-300 mt-auto">
        <div className="flex justify-center gap-6 mb-2">
          <Link to="/" className="hover:text-primary-500">Home</Link>
          <Link to="/faq" className="hover:text-primary-500">FAQ</Link>
          <Link to="/contact" className="hover:text-primary-500">Contact</Link>
        </div>
        <span>&copy; {new Date().getFullYear()} My Video Gallery</span>
      </footer>
    </div>
  );
}

function FAQItem({ question, answer }) {
  return (
    <div className="bg-white border border-primary-300 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-primary-500 mb-2">{question}</h3>
      <p className="text-primary-800">{answer}</p>
    </div>
  );
}

export default FAQPage;
